import { AppRouteConfig, breadcrumbs } from '..';

export enum SystemRouteName {
	system = 'System',
	auditLogList = 'AuditLogList',
	auditLogDetails = 'AuditLogDetails',
}

export function systemRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: 'audit-logs',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: SystemRouteName.auditLogList,
					component: () => import('../../views/system/AuditLogs.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('auditLogList'),
						],
						caslSubject: 'system.audit_logs',
						caslAction: 'view',
						maskFeature: ['system'],
					},
				},
				{
					path: ':id',
					name: SystemRouteName.auditLogDetails,
					component: () => import('../../views/system/AuditLogDetails.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('auditLogList'),
							breadcrumbs.get('auditLogDetails'),
						],
						caslSubject: 'system.audit_logs',
						caslAction: 'view',
					},
				},
			],
		},
	];
}
